export abstract class ObjectBaseService {
  abstract update(object: any)
  abstract appUsers()
  abstract accountUsers()
  abstract appSuites();

  public savePublicUuid(object: any) {
    return this.update(object);
  }
}